/*
 * Klaviyo cart permalinks.
 * render at: layout/theme.liquid
 * docs: https://shopify.dev/docs/apps/checkout/cart-permalinks/create, https://community.shopify.com/c/shopify-design/cart-use-permalinks-to-pre-load-the-cart/td-p/613702, https://gist.github.com/ryankelly-klaviyo/fe7b9f581d768e7875d1f017c9102ac5
 */

/*
  case #1 
  - trigger by default add to cart form
  - product with id and quantity
  https://fashionablecanes.com/cart/40238887239813:1
  product:https://fashionablecanes.com/products/standard-black-rubber-cane-tips
  
  case #2 - 
  - product with id, quantity and notes
  - trigger by default add to cart form witout changing length dropdown
  https://fashionablecanes.com/cart/40238133411973:1?attributes[CANE-DEFAULT-SIZE]=37.5&attributes[LENGTH]=Standard-Size
  product:https://fashionablecanes.com/products/oak-derby-cane?variant=40238133411973
  
  case #2.1
  - product with id, quantity and notes
  - trigger by default add to cart form and changing lenght dropdown
  https://fashionablecanes.com/cart/40238133411973:1?attributes[LPROP]=Exchange-Only&attributes[CANE-DEFAULT-SIZE]=37.5&attributes[LENGTH]=32.5
  product:https://fashionablecanes.com/products/oak-derby-cane?variant=40238133411973
*/

const SHOP_URL = 'https://fashionablecanes.com'

// Case #1, #2 and 2.1
const form = document.querySelector("[data-js-product-form]");
//console.log({ form });

// Store the original method
let tmp = form.submit;

form.addEventListener("submit", (e) => {
  e.preventDefault();
  e.stopPropagation();

  const dataForm = formToJSON(e.target.elements);
  //console.log("c1", dataForm);

  // https://fashionablecanes.com/products/oak-derby-cane?variant=40238133411973
  let notes = ""
  const properties = ['properties[_LPROP]', 'properties[*Length*]', 'properties[_CANE-DEFAULT-SIZE-TAG]']
  for (const [key, value] of Object.entries(dataForm)) {
    if(properties.includes(key)){ 
      if(key === 'properties[_CANE-DEFAULT-SIZE-TAG]'){
          //console.log(`v: ${key}: ${value}`);
          notes += `attributes[CANE-DEFAULT-SIZE]=${value}&attributes`
      }

     if(key === 'properties[*Length*]'){
          //console.log(`v2: ${key}: ${value}`);
          notes += `[LENGTH]=${value.includes("*") ? value.replace(/\*/g, '') : value.replace(" ", "-")}`
      }

      if(key === 'properties[_LPROP]' && value !== ""){
          //console.log(`v3: ${key}: ${value}`);
          notes += `attributes[LPROP]=${value?.replace(" ", "-")}&`
      }  
    }
  }

  const link = `${SHOP_URL}/cart/${dataForm.id}:${dataForm?.quantity ?? 1}`;
  const permaLink = notes !== '' ? `${link}?${notes}` : link
 
  //console.log(permaLink)
 
  klaviyo.push(['track', 'Added to Cart', permaLink]);

  // Trigger form
  tmp.apply(form);
});

// Case #3 - engraving product with zepto modal CTA "Add engraving to..." - https://fashionablecanes.com/products/oak-derby-cane?variant=40238133411973
// CAN'T found information regardin adding line properties to permalinkg

//const personalizeItCTAtext = document.querySelector('[data-js="zepto-trigger"]')

// if(personalizeItCTAtext){
//   personalizeItCTAtext?.addEventListener('click', ()=> {

//   console.log("Detect zepto form element")
//   whenAvailable(".pplr_form.pplr_atc_form", function(el) {
//     //check line properties values from json
//     console.log(el)

//     const forms = document.querySelectorAll('form')
//     console.log("forms", forms)
//     forms.forEach(f =>{
//         f.addEventListener('submit', async (e)=>{
//            e.preventDefault();
//           e.stopPropagation();
//           e.stopImmediatePropagation();
//           console.log("xd")

//         })
//     })
    

//     let tmp = el.submit;

//     const btn = document.querySelector('.p_a_t_c.btn.pplr-btn')

//     if(!btn){
//       console.log("C#2, can't found zepto engraving modal trigger button")
//       return
//     }

//     btn.addEventListener('click', async (e)=>{
//       console.log("c33")
//       await sleep(5000)
//       e.preventDefault();
//       e.stopPropagation();
//       e.stopImmediatePropagation();

//       const dataForm = formToJSON(el.target.elements);
//      console.log("c2", dataForm);
//     })

    

//       el.addEventListener("submit", async (e) => {
//             console.log("c44")
//         await sleep(5000)
//       e.preventDefault();
//       e.stopPropagation();
//       e.stopImmediatePropagation();

//      const dataForm = formToJSON(e.target.elements);
//      console.log("c2", dataForm);

//        //tmp.apply(el);
      
//     })
 
   
//   })
// })
// }

const formToJSON = (elements) =>
  [].reduce.call(
    elements,
    (data, element) => {
      data[element.name] = element.value;
      return data;
    },
    {}
  );


// detect zepto loaded
function whenAvailable(DOM_element, callback) {
   const zeptoEl = document.querySelector(DOM_element)

   const int = window.setTimeout(function() {
       if (zeptoEl) {
           callback(zeptoEl);
           clearInterval(int)
       } else {
           whenAvailable(DOM_element, callback);
       }
   }, 1000);
 }



// get cart data
async function getCartData() {
  try {
    const res = await fetch("/cart.js");
    const data = await res.json();
    return data;
  } catch (error) {
    console.log("Error fetching cart data", error);
  }
}

// replace for using setTimeout
async function sleep(time = 1000) {
  return new Promise((res, rej) => {
    setTimeout(res, time);
  });
}


